import React from "react";
import { useCompleteProfile } from "@/context/CompleteProfileContext";
import CompleteProfileFooter from "../CompleteProfileFooter";
import { ImprovedOccupationAutocomplete } from "@/components/onboarding/ImprovedOccupationAutocomplete";
import { ImprovedEducationAutocomplete } from "@/components/onboarding/ImprovedEducationAutocomplete";
import { useAuth } from "@/hooks/useAuth";
import { Briefcase, GraduationCap } from "lucide-react";

const CareerStep = () => {
  const { data, updateData, autoSaveField, nextStep, saving } = useCompleteProfile();
  const { profileData } = useAuth();

  const handleOccupationChange = (value: string) => {
    updateData({ occupation: value });
    autoSaveField('occupation', value); // Auto-save on selection
  };

  const handleEducationChange = (value: string) => {
    updateData({ education: value });
    autoSaveField('education', value); // Auto-save on selection
  };

  // Both fields required
  const canProceed = Boolean(data.occupation && data.education);

  return (
    <CompleteProfileFooter
      buttonText="Continuar"
      onClick={nextStep}
      disabled={!canProceed}
      isLoading={saving}
    >
      <div className="space-y-6">
        {/* Header */}
        <div className="text-center space-y-2">
          <div className="w-16 h-16 rounded-full bg-luxury-pinkBright/20 flex items-center justify-center mx-auto mb-4">
            <Briefcase className="w-8 h-8 text-luxury-pinkBright" />
          </div>
          <h2 className="text-2xl font-bold text-white">Profissão e Formação</h2>
          <p className="text-white/60 text-sm">
            Informe sua área de atuação e formação acadêmica
          </p>
        </div>

        {/* Form Fields */}
        <div className="space-y-5">
          {/* Occupation */}
          <div className="space-y-2">
            <label className="text-sm font-medium text-white/80 flex items-center gap-2">
              <Briefcase className="w-4 h-4" />
              Profissão
              <span className="text-luxury-pinkBright">*</span>
            </label>
            <ImprovedOccupationAutocomplete
              value={data.occupation || ""}
              onChange={handleOccupationChange}
              userRole={profileData?.role || "sponsor"}
            />
          </div>

          {/* Education */}
          <div className="space-y-2">
            <label className="text-sm font-medium text-white/80 flex items-center gap-2">
              <GraduationCap className="w-4 h-4" />
              Formação
              <span className="text-luxury-pinkBright">*</span>
            </label>
            <ImprovedEducationAutocomplete
              value={data.education || ""}
              onChange={handleEducationChange}
            />
          </div>
        </div>

        {/* Info box */}
        <div className="bg-white/5 border border-white/10 rounded-xl p-4 mt-6">
          <p className="text-sm text-white/70 text-center">
            💼 Essas informações ajudam a encontrar conexões compatíveis
          </p>
        </div>
      </div>
    </CompleteProfileFooter>
  );
};

export default CareerStep;
